

module.exports = __webpack_require__.stylable.create(
    "InfoSectionTitle3095652555",
    {"classes":{"root":"InfoSectionTitle3095652555__root"},"vars":{},"stVars":{"titleTextColor":"'\"fallback(color(--productPage_infoSectionTitleTextColor), color(--quickView_infoSectionTitleTextColor), color(--productPage_paragraphTitleColor), color(color-5))\"'"},"keyframes":{}},
    "",
    14,
    "InfoSectionTitle3095652555",
    null
);
